<div class="listado-page">
    <div class="listado__stats">
        <div class="listado__stat">
            <div class="listado__stat-value">{{ totalTramites }}</div>
            <div class="listado__stat-label">{{ 'COMMON.LIST.TOTAL' | translate }}</div>
        </div>
        <div class="listado__stat">
            <div class="listado__stat-value is-muted">{{ tramitesMostrados }}</div>
            <div class="listado__stat-label">{{ 'COMMON.LIST.SHOWING' | translate }}</div>
        </div>
    </div>

    <div class="listado-toolbar">
        <input type="text" class="em-input" (keyup)="applyFilter($event)" [placeholder]="'PLACEHOLDER.BUSCAR' | translate">
    </div>

    <div class="listado-table-wrapper listado listado--cards-accent">
        <table mat-table *ngIf="dataSource" #table [dataSource]="dataSource"
            matSort matSortActive="Fecha" matSortDirection="desc"
            class="mat-elevation-z0">

            <ng-container matColumnDef="DNI">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRAMITE_LIST.COLUMN.DNI' | translate }}</th>
                <td mat-cell *matCellDef="let object" [attr.data-label]="'TRAMITE_LIST.COLUMN.DNI' | translate">{{ object['DNI'] }}</td>
            </ng-container>

            <ng-container matColumnDef="Nombre del trámite">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRAMITE_LIST.COLUMN.NAME' | translate }}</th>
                <td mat-cell *matCellDef="let object" [attr.data-label]="'TRAMITE_LIST.COLUMN.NAME' | translate" data-role="title">
                    {{ object['Nombre del trámite'] }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Fecha">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRAMITE_LIST.COLUMN.DATE' | translate }}</th>
                <td mat-cell *matCellDef="let object" [attr.data-label]="'TRAMITE_LIST.COLUMN.DATE' | translate" data-role="meta">
                    {{ formatDate(object['Fecha']) }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Estado">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TRAMITE_LIST.COLUMN.STATUS' | translate }}</th>
                <td mat-cell *matCellDef="let object" [attr.data-label]="'TRAMITE_LIST.COLUMN.STATUS' | translate" data-role="status">
                    <span *ngIf="getEstadoTipo(object)" class="badge-estado" [ngClass]="'estado-' + getEstadoTipo(object)">
                        {{ getEstadoLabel(object) }}
                    </span>
                    <ng-container *ngIf="!getEstadoTipo(object)">{{ getEstadoLabel(object) }}</ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="Acciones">
                <th mat-header-cell *matHeaderCellDef class="em-th-actions">{{ 'TRAMITE_LIST.COLUMN.ACTIONS' | translate }}</th>
                <td mat-cell *matCellDef="let object" class="em-td-actions" data-role="actions" [attr.data-label]="'TRAMITE_LIST.COLUMN.ACTIONS' | translate">
                    <ng-container *ngIf="object['Acciones'] as t">
                        <span *ngIf="esTramiteBajaSoloConsulta(t.estadoFirma)" class="text-muted">—</span>
                        <div class="em-actions-wrap" *ngIf="!esTramiteBajaSoloConsulta(t.estadoFirma)">
                            <button [disabled]="actionProgres" type="button" class="em-icon-btn"
                                *ngIf="puedeEditar(object, t)"
                                [matTooltip]="'TRAMITE_LIST.ACTION.EDIT' | translate"
                                matTooltipClass="em-tooltip"
                                matTooltipPosition="left"
                                (click)="resumeTramite(object)">
                                <img src="assets/gestion-tramites/eye.svg" alt="">
                            </button>
                            <button [disabled]="actionProgres" type="button" class="em-icon-btn"
                                *ngIf="puedeDescargar(t)"
                                [matTooltip]="'TRAMITE_LIST.ACTION.DOWNLOAD' | translate"
                                matTooltipClass="em-tooltip"
                                matTooltipPosition="left"
                                (click)="descargarJustificante(t)">
                                <img *ngIf="!estaDescargando(t)" src="assets/gestion-tramites/download.svg" alt="">
                                <div class="spinner-border spinner-border-sm" *ngIf="estaDescargando(t)"></div>
                            </button>
                            <button [disabled]="actionProgres" type="button" class="em-icon-btn"
                                *ngIf="t.estadoFirma=='PENDIENTE_DE_FIRMA'"
                                [matTooltip]="'TRAMITE_LIST.ACTION.SIGN' | translate"
                                matTooltipClass="em-tooltip"
                                matTooltipPosition="left"
                                (click)="signTramite(t)">
                                <img src="assets/gestion-tramites/signature-solid.svg" alt="">
                            </button>
                            <button [disabled]="actionProgres" type="button" class="em-icon-btn"
                                *ngIf="t.estadoFirma=='FIRMADO_SIN_REGISTRO'"
                                [matTooltip]="'TRAMITE_LIST.ACTION.REGISTER' | translate"
                                matTooltipClass="em-tooltip"
                                matTooltipPosition="left"
                                (click)="registrarTramite(t)">
                                <img src="assets/gestion-tramites/export-variant.svg" alt="">
                            </button>
                            <button [disabled]="actionProgres" type="button" class="em-icon-btn"
                                *ngIf="puedeEliminar(t)"
                                [matTooltip]="'TRAMITE_LIST.ACTION.DELETE' | translate"
                                matTooltipClass="em-tooltip"
                                matTooltipPosition="left"
                                (click)="deleteTramite(t)">
                                <img src="assets/gestion-tramites/trash-can-outline.svg" alt="">
                            </button>
                        </div>
                    </ng-container>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                [ngClass]="'card-' + getEstadoTipo(row)"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5" showFirstLastButtons></mat-paginator>

    <div class="w-100 mt-3 alertPuestosNot">
        <img src="assets/triangle-exclamation.svg" class="iconAlertNot" />
        {{ 'TRAMITE_LIST.AUTO_BAJA_WARNING' | translate:{ dias: diasCaducidad } }}
    </div>
    <button *ngIf="dataSource && isAdmin" class="btn btn-primary m-left" (click)="exportarCsv()">{{ 'TRAMITE_LIST.EXPORT_CSV' | translate }}</button>
    <div class="modal fade show" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
        [ngStyle]="{'display':displayFirma}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5>{{ 'TRAMITE_LIST.SIGN.TITLE' | translate }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="displayFirma='none'">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h6>{{ 'TRAMITE.SIGN.METHOD' | translate }}</h6>
                </div>
                <div class="modal-footer">
                    <fieldset [disabled]="actionProgres" [class]="isInProgress?'activated':'not-activated'">
                        <boton-listado>
                        </boton-listado>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
    <form id="firma" (submit)="resultchange($event)" class="">
        <input type="hidden" id="result" />
        <input type="hidden" id="error" />
        <input type="hidden" id="certifcado" />
    </form>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="true" [name]="'litado_tramites_spinner'">
        <p style="color: white">{{mensajeSpinner}}</p>
    </ngx-spinner>
</div>
